function snapshotSummary(rule) {
    if (!rule) return "";
    if (rule.kind === "includes") return rule.pattern || "—";
    if (rule.kind === "exactList") {
        const lines = (rule.patterns || []).filter(Boolean).slice(0, 2);
        const more = (rule.patterns || []).filter(Boolean).length > 2 ? "…" : "";
        return lines.join(", ") + more || "—";
    }
    if (rule.kind === "any") return `${(rule.clauses || []).length} умов (АБО)`;
    return "—";
}

/** Плаваюча картка під час pointer-drag (трекпад / миша / тач). */
export default function ProductNameNormalizeRulesDragLayer({ active, clientX, clientY, grabOffsetX, grabOffsetY, snapshot }) {
    if (!active || !snapshot) {
        return null;
    }

    const left = clientX - grabOffsetX;
    const top = clientY - grabOffsetY;

    const kindLabel =
        snapshot.kind === "includes"
            ? "Містить підрядок"
            : snapshot.kind === "exactList"
              ? "Точний збіг"
              : "Умова АБО";

    return (
        <div
            className="pnn-pointer-drag-layer"
            style={{
                position: "fixed",
                inset: 0,
                pointerEvents: "none",
                zIndex: 10000,
            }}
            aria-hidden
        >
            <div
                className="pnn-drag-floating-card"
                style={{
                    position: "absolute",
                    left,
                    top,
                    maxWidth: "min(92vw, 640px)",
                    transform: "rotate(-1.2deg)",
                    transformOrigin: "0 0",
                }}
            >
                <div className="pnn-drag-floating-card__badge">{kindLabel}</div>
                <div className="pnn-drag-floating-card__body text-truncate">{snapshotSummary(snapshot)}</div>
                <div className="pnn-drag-floating-card__result text-truncate">
                    → <strong>{snapshot.result || "…"}</strong>
                </div>
            </div>
        </div>
    );
}
